import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MaxBrainExperience } from 'app/library/experience/models/experience.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';

@Component({
    selector: 'app-add-experience-dialog',
    templateUrl: './add-experience-dialog.component.html',
    styleUrls: ['./add-experience-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class AddExperienceDialogComponent extends UnsubscribeOnDestroy {
    @Input()
    experiences: MaxBrainExperience[];

    @Output()
    save = new EventEmitter<string>();

    experienceCtrl = new FormControl(null);

    constructor(public dialogRef: MatDialogRef<AddExperienceDialogComponent>) {
        super();
    }
}
